/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sub_Quotas_Save_ChangesInputs */



/**
* | output |
* | --- |
* | "Save {count} change(s)" |
*
* @param {Sub_Quotas_Save_ChangesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_save_changes = /** @type {((inputs: Sub_Quotas_Save_ChangesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_Save_ChangesInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Änderung(en) speichern`)
	return /** @type {LocalizedString} */ (`Save ${i?.count} change(s)`)
});